import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap, withLatestFrom } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Floor } from '@era/locations-sdk';

import { FloorStoreActions } from '../floor/index';

import { LocationsRouterStoreSelectors, RouterStoreStates } from '../router/index';

@Injectable()
export class FloorResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly floorStore: Store<Floor>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(LocationsRouterStoreSelectors.selectLocationHumanId).pipe(
      withLatestFrom(this.routerStore.select(LocationsRouterStoreSelectors.selectBrandHumanId)),
      tap(([locationId, brandId]) => {
        this.floorStore.dispatch(
          FloorStoreActions.FloorResolverActions.floorsRequested({
            locationId,
            brandId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
